import { render } from "./WpeText.vue?vue&type=template&id=c5db2ce0"
import script from "./WpeText.vue?vue&type=script&lang=js"
export * from "./WpeText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5db2ce0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5db2ce0', __exports__)) {
    api.reload('c5db2ce0', __exports__)
  }
  
  module.hot.accept("./WpeText.vue?vue&type=template&id=c5db2ce0", () => {
    api.rerender('c5db2ce0', render)
  })

}


export default __exports__